import * as React from 'react';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
import { UserIcon } from './UserIcon';
import { PhoneIcon } from './PhoneIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export function mapTypeToIcon(type) {
  switch (type) {
    case ERememberedAccountType.Email:
      return /*#__PURE__*/_jsx(UserIcon, {});
    case ERememberedAccountType.Phone:
      return /*#__PURE__*/_jsx(PhoneIcon, {});
    default:
      return null;
  }
}